'use client';

import React, { FC } from 'react';

import PartFeedback from '@/components/part-feedback';
import PartPageBanner from '@/components/UI/part-page-banner';
import PartServicesDecor from '@/components/UI/part-services-decor';
import { IListCases } from '@/contentful/utils/cases';
import { ICategoryPage } from '@/contentful/utils/categoryPage';
import { IForm } from '@/contentful/utils/form';
import { useLanguage } from '@/context/LanguageContext';

import PartCasesList from './part-cases-list/part-cases-list';

interface IPartCasesView {
  data: {
    casesPages: ICategoryPage[];
    listCases: IListCases[];
    forms: IForm[];
  };
}

const PageCasesView: FC<IPartCasesView> = ({ data }) => {
  const { language } = useLanguage();
  const casesPage = data.casesPages.filter((item) => item.lang === language)[0];

  const casesList = data.listCases.filter((item) => item.lang === language);

  const casesForm = data.forms.filter((item) => item.lang === language)[0];

  const casesPageBannerData = {
    title: casesPage.title,
    imageDesktop: casesPage.imageDesktop,
    imageMobile: casesPage.imageMobile,
  };

  const casesPageData = {
    lang: language,
    cases: casesList,
    buttonTitle: casesPage.buttonTitle,
  };

  return (
    <>
      <PartPageBanner data={casesPageBannerData} category />
      <PartCasesList data={casesPageData} />
      <PartFeedback data={casesForm} />
      <PartServicesDecor />
    </>
  );
};

export default PageCasesView;
